////////////////////////////////////////////////////////////////////////////////
// News
////////////////////////////////////////////////////////////////////////////////

class News extends Pages {

	constructor(entry, handle) {
		super(entry)
		this.handle = handle || 'news'
	}

	// ===========================================================================
	// Initialisation
	// ===========================================================================

	init(entry) {

		this.isLandingPage = entry.slug == this.handle

		// super.init(entry);

	}

	// ===========================================================================
	// Load In
	// ===========================================================================

	in (content, done) {

		// Animating in to the entry page ==========================================

		if ( !this.isLandingPage ) {

			if ( this.debug ) { console.log('News Entry Page In Animation') }

			super.in(content, done);

		}

		// Animating in to the landing page ========================================

		if ( this.isLandingPage ) {

			if ( this.debug ) { console.log('News Landing Page In Animation') }

			document.body.classList.remove('landing')

			content = $(this.entry.html)

			$('site-wrapper > *:last-child').before(content)

			let articles = content.find('.article')

			// Animate the Header Out
			TweenMax.set(content.filter('header'), this.transition.in.from)
			TweenMax.to(content.filter('header'), 0.5, this.transition.in.to, 0.2)

			if ( articles.length ) {

				TweenMax.set(articles, this.transition.in.from)
				TweenMax.staggerTo(articles, 0.5, Object.assign(this.transition.in.to, {delay: (window.firstvisit ? 1 : 0.5)}), 0.2, done);

			} else {

				done()
			}

			$('.articles-list + button.show-more').on('click', this.showmore.bind(this))

		}

		if ( this.handle == 'new' ) {
			setTimeout(new StayInformed(), 10000);
		}

	}

	// ===========================================================================
	// Load Out
	// ===========================================================================

	out (content, done) {

		// Animating out from the entry page =======================================
		if ( !this.isLandingPage || this.entry.slug != this.handle ) {
			console.log('Animating out from the News entry page')
			super.out(content, done);
		}

		// Animating out from the landing page =====================================

		else if ( this.isLandingPage ) {

			// Define the article element that is the parent element of the <a> that was clicked.
			let isTargetElementAnArticle = $(this.element).parent('.article').length

			if ( isTargetElementAnArticle ) {

				var article = $(this.element).parent('.article')

				let inviewArticle = article.siblings().inview()

				// Seperate the visible and non-visible articles
				var [visibleArticles, hiddenArticles] = inviewArticle ? Object.values(inviewArticle) : [null, null]

				if ( !visibleArticles ) {
					visibleArticles = article.siblings()
				}

				// Grab the figure element as this had usable data attributes on inspect
				var figure = article.find('figure')

				// Find the image element within the figure
				var image = figure.find('img')

				// Get the image ID if it exists
				var imageID = parseInt(figure.attr('data-id'), 10) || false

				// Look for the image element and check if it matches a default-image fallback
				var hasArticleHaveFeaturedImage = imageID && !(image[0].src).includes('default-featured.jpg')

				// Completely remove the the articles that aren't in view
				if ( hiddenArticles && hiddenArticles.length ) {
					if ( 'remove' in hiddenArticles ) {
						hiddenArticles.remove()
					} else {
						hiddenArticles.forEach(item => item.remove())
					}
				}

			}

			try {

				if ( !isTargetElementAnArticle ) {
					throw 'This is not a article'
				}

				if ( !hasArticleHaveFeaturedImage ) {
					throw 'No featured Image was used in this article'
				}

				console.log('Trying to animate out all articles except the current article so we can do something fancy with it')

				// Fetch the thumbnail in higher resolution
				fetcher.get('/fetch-assets', { transform : featured || {mode: "fit", width: 1080}, id : imageID }, {

					success : (response) => {

						console.log(response)

						// Make sure there is atleast one asset returned
						if (response.length) {

							// Use the Image API for load the new image
							let newImage = new Image();

							// When the image data has loaded, start the out transitions
							newImage.onload = (event) => {

								// Update the image data throughout the figure image elements
								// to the new HD image path.
								image.attr({'src': event.target.src, 'data-desktop': event.target.src})

								// Transition out all visible articles
								TweenMax.staggerTo(visibleArticles, 0.3, this.transition.out.to, 0.1, () => {

									// Apply the 'current' class to the article so the CSS can remove
									// all the elements bar the image.
									article.addClass('current')

									// Get the image positioning so we know how to offset it
									let position = article[0].getBoundingClientRect();

									// Animate the Header Out
									TweenMax.to(content.filter('header'), 0.5, this.transition.out.to, 0.2)

									// Move the figure asset to the very top and left position.
									// And resize it to the viewport width and height.
									TweenMax.to(figure, 0.5, {
										delay  : 0.5,
										top    : - position.top,
										left   : - position.left,
										width  : window.width - (Scroll.width || 0),
										height : window.height,
										ease   : Expo.easeOut,
										onComplete : () => {
											if (typeof done == 'function') {
												article.removeClass('current').css('overflow','hidden')
												TweenMax.set(figure, { top : 0, left : 0, width : '100%', height : '' })
												// let articlesList = article.parents('.articles-list')
												// if ( articlesList.length ) {
													// articlesList.first().attr('data-offset', parseInt(articlesList.attr('data-limit'),  10) || 6)
												// }
												done()
												// Stop the slide show from animating on the next page.
												$('slide-show').attr('data-direction', '')
											}
										},
										onStart : () => {
											article.css('overflow','visible')
										}
									})
								})
							}

							// Define the image src
							newImage.src = response[0]

						} else {
							throw 'Failed to find a file for asset id' + imageID
						}
					},
					error : (response) => { throw 'Failed to find a file for asset id' + imageID }
				})

			}	catch(error) {

				console.warn(error)

				let articles = $('.article')

				if ( articles.length ) {

					try {
						// Seperate the visible and non-visible articles
						var [visibleArticles, hiddenArticles] = Object.values(articles.siblings().inview())

						// Completely remove the the articles that aren't in view
						if ( hiddenArticles && hiddenArticles.length ) {
							if ( 'remove' in hiddenArticles ) {
								hiddenArticles.remove()
							} else {
								hiddenArticles.forEach(item => item.remove())
							}
						}

					} catch(error) {

					}

					// let articlesList = articles.parents('.articles-list')
					// console.log('articlesList', articlesList)
					// if ( articlesList.length ) {
						// articlesList.first().attr('data-offset', parseInt(articlesList.attr('data-limit'),  10) || 6)
					// }

					// Animate the Header Out
					TweenMax.to(content.filter('header'), 0.5, this.transition.out.to, 0.2)

					TweenMax.staggerTo(articles, 0.3, this.transition.out.to, 0.1, () => {
						if (typeof done == 'function') { done() }
					})

				} else {

					super.out(content, done)

				}
			}
		}
	}

	// ===========================================================================
	// Show More
	// ===========================================================================

	showmore(event) {

		event.preventDefault()

		let button = $(event.currentTarget)
		let articlesList = $('.articles-list').first()
		let limit  = parseInt(articlesList.attr('data-limit'),  10) || 6
		let offset = parseInt(articlesList.attr('data-offset'), 10) || 0
		let total  = parseInt(articlesList.attr('data-total'),  10) || 100

		let settings = {
			template : `/${this.handle}/_articles.twig`,
			limit    : limit,
			offset   : offset,
			siteId   : document.documentElement.dataset.localeId || 1
		}

		historyAPI.loading = true

		fetcher.get('/fetch-template', settings, {
			success : (response) => {

				let articles = $(response.html).filter('.article')

				articlesList.append(articles)
				Scroll.to(articles.first(), -32)

				TweenMax.set(articles, page.transition.in.from)
				TweenMax.staggerTo(articles, 0.5, page.transition.in.to, 0.2)

				historyAPI.loading = false

				let newOffset = offset + articles.length

				if ( newOffset >= total ) {
					button.addClass('loaded').text('No More Articles')
					console.log(`all ${total} are listed`)
				} else {
					articlesList.attr('data-offset', offset + articles.length)
					console.log(`showing ${newOffset} of ${total}`)
				}
			},
			error : (response) => {

				historyAPI.loading = false
				console.error('error', response)

			}
		})


	}

}
